export default "__VITE_ASSET__DB_5O3PG__"